module.exports = __webpack_public_path__ + "static/img/photo4.cb03b577.jpg";